/* eslint-disable react-refresh/only-export-components */
import { createContext, useContext } from 'react';

import type { TableContextValue } from './types';

/**
 * React Context for table state.
 *
 * Each DataTable creates its own context, providing natural isolation
 * for multiple tables on the same page without jotai-scope complexity.
 */
export const TableContext = createContext<TableContextValue | null>(null);

/**
 * Provider component for table context.
 */
export const TableProvider = TableContext.Provider;

/**
 * Hook to access table context.
 * Must be used within a DataTable component.
 * Throws an error if used outside a DataTable.
 */
export const useTable = <TData = unknown,>(): TableContextValue<TData> => {
  const context = useContext(TableContext);
  if (!context) {
    throw new Error('useTable must be used within a DataTable component');
  }
  return context as TableContextValue<TData>;
};
